module.exports = __webpack_public_path__ + "static/media/Flow-QRCash.b8f519b7.png";